// extracted by mini-css-extract-plugin
module.exports = {"recordBar":"styles_recordBar__1exNk","record":"styles_record__3zQR9"};